import React from 'react';
import './loading.scss'; // Estilos CSS para o spinner

const LoadingSpinner = () => {
  return (
    <div className="loading-spinner-container">
      <div className="loading-spinner"></div>
    </div>
  );
};

export default LoadingSpinner;
